import { render, staticRenderFns } from "./ChangeStatusForm.vue?vue&type=template&id=0c516fd2&scoped=true&"
import script from "./ChangeStatusForm.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusForm.vue?vue&type=style&index=0&id=0c516fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c516fd2",
  null
  
)

export default component.exports